import ComponentRegistry from 'common/util/ComponentRegistry';

const Select = ComponentRegistry.register(
	function($context) {
		return $context.select('.select:not(select)');
	},
	function($select) {
		const _private = {
			$select: $select.find('.select__control'),
			tree: null,
			has_change: false,
			update_request_id: null,
			visible: false,
			is_clicked: false,

			initObserver: function() {
				const observerCreate = new MutationObserver(function() {
					_private.buildTree();
				});
				observerCreate.observe(_private.$select.get(0), {
					subtree: true,
					childList: true
				});
				const observerUpdate = new MutationObserver(function(entities) {
					let has_update = false;

					entities.forEach(function(entity) {
						if (entity.attributeName !== 'id') {
							has_update = true;
						}
					});

					if (!has_update) {
						return;
					}

					_private.updateTree();
				});
				observerUpdate.observe(_private.$select.get(0), {
					subtree: true,
					attributes: true,
					characterData: true
				});
			},

			handleMouseUp: function() {
				_private.is_clicked = false;
			},

			handleResize: (function() {
				let request_id = null;

				return function() {
					cancelAnimationFrame(request_id);
					request_id = requestAnimationFrame(function() {
						_private.updateWidth();
					}, $select[0]);
				};
			})(),

			initEventListeners: function() {
				_private.$select.on('refresh', function(e) {
					_private.updateTree();
				});

				_private.$select.on('refreshWidth',  _private.handleResize);

				_private.$select.on('change', function(e) {
					_private.updateTree();

					if (_private.isOpen()) {
						e.preventDefault();
						e.stopPropagation();
						e.stopImmediatePropagation();

						_private.has_change = true;
					}
				});

				$select.on('mousedown', function() {
					_private.is_clicked = true;
				});

				$(document).on('mouseup', _private.handleMouseUp);

				$(window).on('resize', _private.handleResize);

				$(document).on('click', function(e) {
					if ($(e.target).closest($select).length === 0) {
						_private.close();
						_private.toggleFocus();
					}
				})

				_private.$select.on('blur', function(e) {
					if (_private.is_clicked) {
						e.preventDefault();
						_private.is_clicked = false;
						if (!_private.isInput()) {
							_private.$select.focus();
						}
						return;
					}

					_private.close();
				});

				_private.$select.on('keydown', function(e) {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
					}

					if (e.key === 'Enter') {
						_private.toggle();
					}

					if (e.key === ' ') {
						_private.open();
					}
				});

				$select.on('click', '.select__option', function() {
					const node = $(this).get(0)['megashop_select@node'];

					if (!node || node.disabled || (node.optgroup && node.optgroup.disabled)) {
						return;
					}

					$(node.control).prop('selected', true);
					$(node.control).trigger('change');

					_private.close();
				});

				$select.on('click', '.select__box', function(e) {
					if (_private.isOpen()) {
						_private.close();
					} else {
						_private.open();
					}
				});

				$select.on('focus', '.select__content_input', function() {
					var $input = $(this);
					$input.val('');
					_private.toggleOptionsByInput();
					_private.toggleFocus(true);
				});

				$select.on('blur', '.select__content_input', function() {
					var $input = $(this);
					var placeholder = $input.attr('placeholder');
					$input.val(placeholder);
				});

				$select.on('input', '.select__content_input', function(e) {
					_private.toggleOptionsByInput();
					_private.open();
				});

				$select.on('animationstart', function(e) {
					if (e.originalEvent.animationName === 'megashop_select_appear') {
						_private.updateTree();
					}
				});

				$(window).on('resize', function() {
					_private.updateTree();
				});

				$select.find('.select__dropdown').cssAnimation('select__dropdown_animated');

				$select.on('click', '.select__content a', function (e) {
					e.preventDefault();
				});
			},

			destroyEventListeners: function() {
				$(document).on('mouseup', _private.handleMouseUp);

				$(window).on('resize', _private.handleResize);
			},

			getSelected: function() {
				const $options = _private.$select.find('option');
				let $option = $();

				$options.each(function() {
					if ($(this).prop('selected')) {
						$option = $(this);
					}
				});

				if ($option.length > 0) {
					return $option.get(0)['megashop_select@node'];
				} else {
					return null;
				}
			},

			isOpen: function() {
				return $select.hasClass('select_open');
			},

			open: function() {
				if (_private.isOpen()) {
					return;
				}

				if (ResponsiveUtil.hasNativeSelect()) {
					return;
				}

				$select.addClass('select_open');

				const $dropdown = $select.find('.select__dropdown');
				$dropdown.removeClass('select__dropdown_up');

				if ($dropdown.get(0).getBoundingClientRect().bottom > window.innerHeight) {
					$dropdown.addClass('select__dropdown_up');
				}

				$dropdown.runCssAnimation('select__dropdown_open-animation');
				_private.scrollToSelected();
			},

			close: function() {
				if (!_private.isOpen()) {
					return;
				}

				$select.removeClass('select_open');
				$select.find('.select__dropdown').runCssAnimation('select__dropdown_close-animation');

				if (_private.has_change) {
					_private.$select.trigger('change');
					_private.has_change = false;
				}
			},

			toggle: function() {
				if (_private.isOpen()) {
					_private.close();
				} else {
					_private.open();
				}
			},

			updateBox: function() {
				const node = _private.getSelected();

				if (!node) {
					return;
				}

				const $content = _private.getContentBlock();

				if (_private.isInput()) {
					const $label = $('<span>').html(node.label);
					const label = $label.text();

					$content.attr({'data-value': node.value, 'placeholder': label}).val(label);
					_private.toggleOptionsByInput();
				} else {
					$content.attr('data-value', node.value).html(node.label);
				}
			},

			updateWidth: function() {
				const $dropdown = $select.find('.select__dropdown');
				const is_open = $select.hasClass('select_open');
				$select.removeClass('select_init');
				$select.removeClass('select_open');

				$dropdown.get(0).style.width = '';
				$select.get(0).style.width = '';

				const body_width = window.bodyWidth;
				let width = Math.max($dropdown.outerWidth(), $select.outerWidth());
				const overflow = $dropdown.get(0).getBoundingClientRect().right + 5 - body_width;

				if (overflow > 0) {
					width -= overflow;
				}

				$dropdown.outerWidth(width);
				$select.outerWidth(width);
				$select.addClass('select_init');

				if (is_open) {
					$select.addClass('select_open');
				}
			},

			buildTree: function() {
				_private.tree = [];
				_private.$select.children().each(function(i) {
					const $control = $(this);

					if ($control.is('option')) {
						_private.tree[i] = _private.buildNodeFromOption($control);
					} else if ($control.is('optgroup')) {
						_private.tree[i] = _private.buildNodeFromOptgroup($control);

						$control.children().each(function(j) {
							const $option = $(this);
							_private.tree[i].options[j] = _private.buildNodeFromOption($option, _private.tree[i]);
						});
					}
				});

				_private.createDropdown();
				_private.updateBox();
				_private.updateWidth();
			},

			buildNodeFromOption: function($option, optgroup) {
				const option = $option.get(0);
				const node = {
					label: $option.data('label') || $option.html(),
					value: $option.val(),
					selected: $option.prop('selected'),
					disabled: $option.prop('disabled'),
					control: option,
					hidden: $option.css('display') === 'none',
					optgroup: optgroup
				};
				option['megashop_select@node'] = node;
				_private.createElementByOptionNode(node);

				return node;
			},

			buildNodeFromOptgroup: function($optgroup) {
				const optgroup = $optgroup.get(0);
				const node = {
					label: $optgroup.attr('label'),
					options: [],
					disabled: $optgroup.prop('disabled'),
					control: optgroup,
					hidden: window.getComputedStyle(optgroup).display === 'none'
				};
				optgroup['megashop_select@node'] = node;
				_private.createElementByOptgroupNode(node);

				return node;
			},

			createDropdown: function() {
				$select.find('.select__dropdown').each(function() {
					const $dropdown = $(this);
					$dropdown.empty();
					const $fragment = $('<div></div>');

					_private.tree.forEach(function(node) {
						$fragment.append(node.element);

						if (node.options) {
							const $optgroup = $(node.element);

							node.options.forEach(function(node) {
								$optgroup.append(node.element);
							});
						}
					});

					$dropdown.append($fragment.contents());
				});
			},

			createElementByOptgroupNode: function(node) {
				const optgroup = document.createElement('span');
				optgroup.classList.add('select__optgroup');
				node.element = optgroup;
				optgroup['megashop_select@node'] = node;

				const label = document.createElement('span');
				label.classList.add('select__optgroup-label');
				label.innerHTML = node.label;
				optgroup.appendChild(label);

				optgroup.classList.toggle('select__optgroup_disabled', node.disabled);
				optgroup.classList.toggle('select__optgroup_hidden', node.hidden);

				return $(optgroup);
			},

			createElementByOptionNode: function(node) {
				const option = document.createElement('span');
				option.classList.add('select__option');
				option.classList.toggle('select__option_disabled', node.disabled);
				option.classList.toggle('select__option_selected', node.selected);
				option.classList.toggle('select__option_hidden', node.hidden);
				option['megashop_select@node'] = node;

				option.dataset['value'] = node.value;
				option.innerHTML = node.label;

				const $option = $(option);
				node.element = $option;

				return $option;
			},

			updateTree: function() {
				cancelAnimationFrame(_private.update_request_id);
				requestAnimationFrame(function() {
					let is_updated = false;

					_private.tree.forEach(function(node) {
						if (node.options) {
							is_updated = _private.updateOptgroupNode(node) || is_updated;

							node.options.forEach(function(node) {
								is_updated = _private.updateOptionNode(node) || is_updated;
							});
						} else {
							is_updated = _private.updateOptionNode(node) || is_updated;
						}
					});

					let visible = $select.is(':visible');

					if (visible !== _private.visible) {
						is_updated = true;
						_private.visible = visible;
					}

					if (is_updated) {
						_private.updateBox();
						_private.updateWidth();

						if (_private.isOpen()) {
							_private.scrollToSelected();
						}
					}

					if ($select.prop('disabled')) {
						_private.close();
					}
				}, $select[0]);
			},

			scrollToSelected: function() {
				const selected = _private.getSelected();

				if (selected) {
					const element = selected.element.get(0);
					const dropdown = $select.find('.select__dropdown').get(0);

					if (dropdown.scrollTop > element.offsetTop) {
						dropdown.scrollTop = element.offsetTop;
					} else if (
						dropdown.scrollTop + dropdown.clientHeight <
						element.offsetTop + element.offsetHeight
					) {
						dropdown.scrollTop = element.offsetTop + element.offsetHeight - dropdown.clientHeight;
					}
				}
			},

			isChangedOptionByNode: function(node) {
				const $option = $(node.control);

				return (
					node.label !== ($option.data('label') || $option.html()) ||
					node.value !== $option.val() ||
					node.disabled !== $option.prop('disabled') ||
					node.selected !== $option.prop('selected') ||
					(node.hidden !== window.getComputedStyle($option.get(0)).display) === 'none'
				);
			},

			updateOptionNode: function(node) {
				if (_private.isChangedOptionByNode(node)) {
					const $option = $(node.control);
					const $element = $(node.element);

					node.label = $option.data('label') || $option.html();
					node.value = $option.val();
					node.disabled = $option.prop('disabled');
					node.selected = $option.prop('selected');
					node.hidden = window.getComputedStyle($option.get(0)).display === 'none';

					$element.html(node.label);
					$element.toggleClass('select__option_disabled', node.disabled);
					$element.toggleClass('select__option_selected', node.selected);
					$element.toggleClass('select__option_hidden', node.hidden);

					return true;
				}

				return false;
			},

			isChangedOptgroupByNode: function(node) {
				const $optgroup = $(node.control);

				return (
					node.label !== $optgroup.html() ||
					node.disabled !== $optgroup.prop('disabled') ||
					(node.hidden !== window.getComputedStyle($optgroup.get(0)).display) === 'none'
				);
			},

			updateOptgroupNode: function(node) {
				if (_private.isChangedOptgroupByNode(node)) {
					const $optgroup = $(node.control);
					const $element = $(node.element);

					node.label = $optgroup.attr('label');
					node.disabled = $optgroup.prop('disabled');
					node.hidden = window.getComputedStyle($optgroup.get(0)).display === 'none';

					const $label = $element.find('.select__optgroup-label');
					$label.html(node.label);
					$optgroup.toggleClass('select__optgroup_disabled', node.disabled);
					$optgroup.toggleClass('select__optgroup_hidden', node.hidden);

					return true;
				}

				return false;
			},

			getContentBlock: function() {
				const $box = $select.find('.select__box');
				return $box.find('.select__content');
			},

			isInput: function() {
				const $content = _private.getContentBlock();

				return $content.hasClass('select__content_input');
			},

			toggleFocus: function(isFocus = false) {
				const $box = $select.find('.select__box');
				$box.toggleClass('select__box_focus', isFocus)
			},

			toggleOptionsByInput: function() {
				if (_private.isInput()) {
					const $input = _private.getContentBlock();
					const value = $input.val().toLowerCase();
					const $options = $select.find('.select__option');

					$options.each(function() {
						const $option = $(this);
						const optionVal = $option.text().toLowerCase();

						$option.toggleClass('select__option_hidden', optionVal.indexOf(value) !== 0);
					});
				}
			}
		};

		_private.initEventListeners();
		_private.initObserver();

		requestAnimationFrame(function() {
			_private.buildTree();
		}, $select[0]);

		return function() {
			_private.destroyEventListeners();
		};
	}
);

export default Select;
